



    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "index",
        components: {},
        mixins:[]
    })
    export default class index extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
